<div class="row">
    <div class="col-md-3 col-12">
        <div class="d-flex flex-wrap">
            <div>
                <label>Starting Date</label>
                <lf-datepicker
                    [(ngModel)]="filters.startDate"
                    [useTimepicker]="false"
                    ngDefaultControl
                ></lf-datepicker>
            </div>

            <label class="mx-2 align-self-end"> to </label>

            <div class="d-inline-block profit-report">
                <label>Ending Date</label>
                <lf-datepicker
                    [(ngModel)]="filters.endDate"
                    [useTimepicker]="false"
                    ngDefaultControl
                ></lf-datepicker>
            </div>
        </div>
    </div>
    <div class="col-md-6 offset-md-3 col-12">
            <label>Shortcuts</label>

            <div class="flex-wrap d-flex justify-content-between">
                <div class="btn-group mr-3">
                    <button
                        (click)="_filteringService.setLastMonthDatePicker(filters); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Last Month
                    </button>
                    <button
                        (click)="_filteringService.setThisMonthDatePicker(filters); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        This Month
                    </button>
                </div>

                <div class="btn-group mr-3">
                    <button
                        (click)="_filteringService.setLastCalendarYearDatePicker(filters); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Last Year
                    </button>
                    <button
                        (click)="_filteringService.setThisCalendarYearDatePicker(filters); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        This Year
                    </button>
                </div>

                <div class="btn-group">
                    <button
                        (click)=" _filteringService.setLastFiscalYearDatePicker(filters, fiscalStartMonth); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        Last Fiscal Year
                    </button>
                    <button
                        (click)="  _filteringService.setThisFiscalYearDatePicker(filters, fiscalStartMonth); parentReloadReport()"
                        class="btn btn-outline-secondary"
                    >
                        This Fiscal Year
                    </button>

                <i class="fa fa-info-circle add-hover"
                   style="margin-top: 10px;"
                   matTooltip="Current Fiscal Year:  {{ getCurrentFiscalYearDisplay() }}"></i>
                </div>
            </div>
            <div class="text-right">
                <a class="btn btn-link" *ngIf="isAdmin" [routerLink]="['/app/settings/organization']">
                    <i class="fa fa-external-link"></i>
                    Manage FY</a>
            </div>

    </div>

</div>
